import Hotfoil from '../components/helpers/hotfoil-mappings';
import { HotfoilEffect } from '../components/hotfoil-effect';

export class HotfoilEffectBuilder {
	static getHotfoil(refinement) {
		return refinement ? Hotfoil.mapper(refinement) : null;
	}

	constructor(hotfoil) {
		if (!hotfoil) {
			return;
		}

		this.hotfoil = hotfoil;
	}

	build(element) {
		if (!this.hotfoil || !element) {
			return undefined;
		}

		return new HotfoilEffect({
			element,
			effect: this.hotfoil.cssClass,
		});
	}

	setOnPopupEvents(popupInstance, selector) {
		if (!this.hotfoil) {
			return;
		}

		popupInstance.subscribe('popup:opened', () => {
			const element = popupInstance.popupContent[0].querySelector(selector);

			this.zoomPopupHotfoil = this.build(element);
		});

		popupInstance.subscribe('popup:closed', () => {
			if (!this.zoomPopupHotfoil) {
				return;
			}

			this.zoomPopupHotfoil.remove();
		});
	}
}
